<template>
  <div class="box">
    <el-button size="small" type="primary" v-print="'#printTest'">
      打印
    </el-button>
    <div id="printTest">
      <div
        class="box_printTest"
        v-for="(item_cm, index_cm) in printArr"
        :key="index_cm"
        style="page-break-after: always"
      >
        <!-- <p
          class="code_tit"
          :style="{
            fontSize: fontSize(0.24) + 'px',
            lineHeight: fontSize(0.3) + 'px',
          }"
        >
          {{ item_cm.name }} {{ item_cm.model }}
        </p>
        <p
          class="code_tit mb15"
          :style="{
            fontSize: fontSize(0.24) + 'px',
            lineHeight: fontSize(0.3) + 'px',
          }"
        >
          {{ item_cm.sn }}
        </p> -->
        <p
          class="tit mb15"
          :style="{
            fontSize: fontSize(0.24) + 'px',
            lineHeight: fontSize(0.3) + 'px',
          }"
        >
          {{ item_cm.name }} {{ item_cm.model }}
          <br />
          {{ item_cm.sn }}
        </p>
        <div class="code_box">
          <PreviewQrCode
            :width="180"
            :height="180"
            :labelNo="'ZQ000' + item_cm.id.toString()"
          ></PreviewQrCode>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  components: {
    PreviewQrCode: () => import("../../views/qrCode/previewQrCode.vue"),
  },
  props: {
    printArr: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    fontSize(res) {
      let clientWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (!clientWidth) return;
      // let fontSize = 100 * (clientWidth / 1920);
      let fontSize = 100 * 1;
      return res * fontSize;
    },
  },
};
</script>

<style scoped>
.box {
  background: white;
  overflow-y: auto;
}
.box_printTest {
  /* width: 100mm;
  height: 55mm; */
  width: 150mm;
  height: 95mm;
  /* font-family: "宋体"; */
  color: black;
  padding-top: 60px;
  box-sizing: border-box;
  /* font-size: 22px;
  line-height: 24px; */
  font-weight: bold;
  text-align: center;
}
.code_box {
  width: 180px;
  margin: 0 auto;
}
.tit {
  margin: 0;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #000000;
}
.code_tit {
  margin: 0;
  font-weight: bold;
}
.mb15 {
  margin-bottom: 10px;
}

/* 去掉页眉页脚 */
@page {
  size: auto;
  margin: 0mm;
}
</style>
